import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WizzardForCombinedPagesMenuFlowModule } from './forCombinedPagesMenuFlow';
import { WizzardForEnhancedMenuFlowModule } from './forEnhancedMenuFlow';
import { WizzardForProductModule } from './forProduct';
import { WizzardForStandardMenuFlowModule } from './forStandardMenuFlow';
import { WizzardForStepThroughMenuFlowModule } from './forStepThroughMenuFlow';
import { WizzardForUpsellModule } from './forUpsell';

import { WizzardTypeComponent } from './wizzard-type.shared.component';

const toExport: any[] = [
    WizzardForCombinedPagesMenuFlowModule,
    WizzardForEnhancedMenuFlowModule,
    WizzardForProductModule,
    WizzardForStandardMenuFlowModule,
    WizzardForStepThroughMenuFlowModule,
    WizzardForUpsellModule,
];

@NgModule({
    declarations: [
        WizzardTypeComponent
    ],
    imports: [
        CommonModule,
        ...toExport
    ],
    exports: [
        WizzardTypeComponent,
        ...toExport
    ],
    providers: [],
})
export class WizzardTypesModule { }
